<app-search-filter-bar
  (valueChange)="onValueChange($event)"
  (toggleFilterEvent)="showFilter.set(!showFilter())"
  (navigateBack)="navigateBack()"
  #searchBar
></app-search-filter-bar>
<div class="workplace-details d-flex flex-row gap-2 justify-content-around mt-4">
  <section class="report-section w-50">
    <div class="workplace-report-container d-flex">
      <div class="mx-2">
        <app-workplace-card
          [workplace]="{
          name: selectedWorkplace()?.name,
          reports: solvedReports(),
          activeReports: activeReports(),
          escalatedReports: escalatedReports()
          }"
          [displayProperties]="this.activeModule() === 'report'
              ? ['activeReports', 'reports']
              : ['escalatedReports']"
          [totalPages]="totalPages()"
          [pagination]="true"
          (emitPageChange)="this.setPage({page: $event.page, tableType: $event.tableType})"
        />
      </div>
      <ng-template #noReports>
        <p>Keine Stillstandsmeldungen</p>
      </ng-template>
    </div>
  </section>
  <section class="filter-section w-50" *ngIf="showFilter(); else diagramSection">
    <app-filter-interface
      #reportFilter
      (filterValueChange)="onFilterValueChange($event)"
      (closeFilterInterface)="showFilter.set(!showFilter())"
    ></app-filter-interface>
  </section>
  <ng-template #diagramSection>
    <div class="d-flex flex-column justify-content-start align-items-center">
      <p class="selected-workplace qundis-section-heading-h2">{{ selectedWorkplace()?.name }}</p>
      <p class="diagram-heading">
        Erfassungszeitraum: {{ getFilterTimeInterval() }}
      </p>
      <div *ngIf="chartData()">
        <app-pie-chart
          [chartData]="chartData()!"
        ></app-pie-chart>
      </div>
    </div>
  </ng-template>
</div>
